// eslint-disable-next-line import/prefer-default-export
export const aiEvents = {
  paymentProviders: {
    totalProcessing: {
      event: "TotalProcessingEvent",
      error: "TotalProcessingError",
    },
  },
  payments: {
    intentToPay: {
      registerRequest: "IntentToPayRegisterRequest",
      registerResult: "IntentToPayRegisterResult",
      update: "IntentToPayUpdate",
      cancel: "IntentToPayCancel",
      completeRequest: "IntentToPayCompleteRequest",
      completeResult: "IntentToPayCompleteResult",
    },
    paymentButtonClicked: "PaymentButtonClicked",
    paymentMethodSelectionClicked: "PaymentMethodSelectionClicked",
    processing: {
      checkStatusError: "PaymentProcessingCheckStatusError",
    },
  },
};

export const aiActions = {
  paymentProviders: {
    totalProcessing: {
      redirectQueryInvalid: "RedirectQueryInvalid",
    },
  },
};

export const aiMetrics = {
  payments: {
    processing: {
      paymentStatusCalls: "PaymentStatusCalls",
      paymentWaitingRedirect: "PaymentWaitingRedirect",
    },
  },
};
